import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Pagination } from '../../models/pagination';

@Component({
	selector: 'pagination-buttons',
	templateUrl: './pagination-buttons.component.html',
	styleUrls: ['./pagination-buttons.component.css'],
})
export class PaginationButtonsComponent implements OnInit {
    @Output() public onNext = new EventEmitter();
    @Output() public onPrev = new EventEmitter();
    @Output() public onFirst = new EventEmitter();
    @Output() public onLast = new EventEmitter();
    @Input() public pagination: Pagination;

    ngOnInit() {
        //
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/controls/pagination-buttons/pagination-buttons.component.ts